import React from 'react';
import { Section } from './ui/Section';
import { Check, X } from 'lucide-react';
export function QualifierSection() {
  return <Section background="night-900" data-id="element-123">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-124">
        {/* For You */}
        <div className="bg-night-950 p-8 rounded-xl border border-green-900/30 shadow-lg" data-id="element-125">
          <h3 className="font-serif text-2xl text-white mb-6 flex items-center gap-3" data-id="element-126">
            <span className="text-green-500" data-id="element-127">✓</span> This Audio Is For You
            If...
          </h3>
          <ul className="space-y-4" data-id="element-128">
            {["You've tried at least five different sleep solutions and each one either stopped working or only partially helped", "You're exhausted by the endless cycle of new symptoms popping up every time you fix an old one", "You suspect your sleep problems are connected to other issues (anxiety, energy crashes, irritability) but nobody's helped you see the pattern", "You're ready to dig deeper than surface symptoms, even if what you find isn't what you expected"].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-129">
                <Check className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-130" />
                <span className="text-slate-300 text-sm leading-relaxed" data-id="element-131">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Not For You */}
        <div className="bg-night-950 p-8 rounded-xl border border-red-900/30 shadow-lg" data-id="element-132">
          <h3 className="font-serif text-2xl text-white mb-6 flex items-center gap-3" data-id="element-133">
            <span className="text-red-500" data-id="element-134">✗</span> This Audio Is NOT For You
            If...
          </h3>
          <ul className="space-y-4" data-id="element-135">
            {["You're looking for a quick fix or sleep meditation", 'You want medical advice or guaranteed outcomes', "You're not willing to investigate what's actually causing your insomnia"].map((item, i) => <li key={i} className="flex gap-3 items-start" data-id="element-136">
                <X className="w-5 h-5 text-red-500 flex-shrink-0 mt-0.5" data-id="element-137" />
                <span className="text-slate-300 text-sm leading-relaxed" data-id="element-138">
                  {item}
                </span>
              </li>)}
          </ul>
        </div>
      </div>
    </Section>;
}